import { render } from "./ThePractice.vue?vue&type=template&id=243d1c9b&scoped=true"
import script from "./ThePractice.vue?vue&type=script&lang=js"
export * from "./ThePractice.vue?vue&type=script&lang=js"

import "./ThePractice.vue?vue&type=style&index=0&id=243d1c9b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243d1c9b"]])

export default __exports__